import React from 'react';
import './SessaoIndisponivel.css';

interface SessaoIndisponivelProps {
  onTentarNovamente: () => void;
}

/**
 * Tela do bootstrap quando o token persistido está expirado e a renovação NÃO
 * pôde ser concluída por falta de conexão com o servidor (at-22).
 *
 * Antes, qualquer falha de refresh deslogava; agora a sessão é preservada — mas
 * preservar a sessão atrás de um spinner eterno seria só trocar "deslogado sem
 * aviso" por "tela travada sem aviso". Então o estado é explícito, diz que a
 * sessão NÃO foi encerrada e oferece uma ação. Há também nova tentativa
 * automática, agendada pelo App (durante a tentativa o gate volta ao loader).
 */
const SessaoIndisponivel: React.FC<SessaoIndisponivelProps> = ({ onTentarNovamente }) => (
  <div className="sessao-indisponivel-overlay">
    <div className="sessao-indisponivel-card">
      <h2>Sem conexão com o servidor</h2>
      <p>
        Não foi possível renovar sua sessão agora. <strong>Sua sessão não foi encerrada</strong> —
        assim que a conexão voltar, você continua de onde parou.
      </p>
      <p className="sessao-indisponivel-dica">
        Verifique sua internet. Estamos tentando novamente automaticamente.
      </p>
      <button type="button" onClick={onTentarNovamente}>
        Tentar novamente
      </button>
    </div>
  </div>
);

export default SessaoIndisponivel;
